// UKG READY (MAIN, APPEND, & MERGE)
import {
  DataSourceSetupComposite,
  enumATSModes
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/DataSourceSetupComposite";
import {
  GetAdditionalTableFields,
  kKeyToLabelAndDefaultText,
  toggleValueInList
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import { appcstr } from "@coreapp/utils/appcstr";

const BuildInputOptions = () => {
  const keys = ["clientID", "clientSecret", "companyID", "domain"];

  return keys.map(key => {
    const option = {
      dataKey: key,
      optional: key === "domain",
      label: appcstr(kKeyToLabelAndDefaultText[key][0]),
      placeholder: appcstr(kKeyToLabelAndDefaultText[key][1]),
      passwordMask: key === "clientSecret"
    };

    if (key === "domain") {
      option.placeholder = "api.paychex.com";
    }

    return option;
  });
};

export const PaychexSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const isAdditionalSource = importType !== "import";
  const atsType = isAdditionalSource ? enumATSModes.notATS : undefined;
  const additionalTables = GetAdditionalTableFields(config.source);
  let { tables } = config;
  let selectedTables = tables ?? [];

  const additionalFieldOptions = additionalTables.map(table => {
    return { value: table.name, label: table.alias };
  });

  const selectedAdditionalFields = selectedTables.map(table => {
    const existingOption = additionalFieldOptions.find(option => option.value === table);
    return existingOption || { value: table, label: table };
  });

  const onTableChange = e => {
    let option = e.value;
    const selectedList = toggleValueInList(selectedTables, option.value);
    onChange({ ...config, tables: selectedList });
  };

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showAdditionalFields
      selectedAdditionalFields={selectedAdditionalFields}
      additionalFieldOptions={additionalFieldOptions}
      onAdditionalFieldChange={onTableChange}
      showConfiguration={isAdditionalSource}
      showLoadHeaders={isAdditionalSource}
      importType={importType}
      ATSType={atsType}
      doInputLookup={false}
      inputOptions={BuildInputOptions()}
    />
  );
};
